module.exports = __webpack_public_path__ + "img/2.58461610.png";